/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';
import { ArrowDownIcon } from './ArrowDownIcon';

const ArrowRightSvg = () => (
  <ArrowDownIcon style={{ transform: 'rotate(270deg)' }} />
);

export const ArrowRightIcon = props => <Icon component={ArrowRightSvg} {...props} />;
